import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Picker from "react-month-picker";
import "../toggleableButton/toggleableButton.css";
import { ArrowIcon } from "../../../assets/images/svg/index";

const MonthPicker = (props) => {
  let { theme, calendarStartDate, calendarEndDate, startDate, endDate } = props;

  const [isVisible, setVisibility] = useState(false);
  const [currentRange, setCurrentRange] = useState({
    from: { year: null, month: null },
    to: { year: null, month: null }
  });
  const [years, setYears] = useState({
    min: { from: null, month: null },
    max: { from: null, month: null }
  });

  useEffect(() => {
    handleDates(calendarStartDate, calendarEndDate, "years");
    handleDates(startDate, endDate, "values");
  }, [props.startDate, props.endDate]);

  const getYearAndMonth = (date) => ({
    year: moment(date).get("year"),
    month: moment(date).get("month") + 1
  });

  let handleDates = (startDate, endDate, rangeType) => {
    let startYearAndMonth = getYearAndMonth(startDate);
    let endYearAndMonth = getYearAndMonth(endDate);

    if (rangeType === "values") {
      let rangeValues = {
        from: startYearAndMonth,
        to: endYearAndMonth
      };
      setCurrentRange((prevState) => ({
        ...prevState,
        ...rangeValues
      }));
    } else if (rangeType === "years") {
      let years = {
        min: startYearAndMonth,
        max: endYearAndMonth
      };
      setYears((prevState) => ({
        ...prevState,
        ...years
      }));
    }
  };

  let handleOnChange = (year, month, idx) => {
    const newRange = { ...currentRange, [idx === 0 ? "from" : "to"]: { year: year, month: month } };
    setCurrentRange(newRange);
    publish(newRange);
  };

  const makeText = (m, dateTo) => {
    if (m && m.year && m.month) {
      const yearStr = m.year.toString();
      const monthStr = (m.month < 10 ? "0" : "") + m.month.toString();
      const dayStr = "01";
      const selectedDate = yearStr + "-" + monthStr + "-" + dayStr;

      if (dateTo) {
        const lastDayOfMonth = moment(moment(selectedDate)).endOf("month").format("YYYY-MM-DD");
        const availableEndDate = moment(calendarEndDate).isBefore(moment(lastDayOfMonth))
          ? calendarEndDate
          : lastDayOfMonth;

        return availableEndDate;
      }
      return selectedDate;
    }
    return "Invalid date";
  };

  const viewComponent = (m) => {
    if (m && m.year && m.month) return PICKER_LANG.months[m.month - 1] + ", " + m.year;
    return "Invalid date";
  };

  const publish = (range = currentRange) => {
    setVisibility(false);
    props.updateDates(makeText(range.from), makeText(range.to, true));
  };

  const PICKER_LANG = {
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    from: "From:",
    to: "To:"
  };

  return (
    <Picker
      theme={theme}
      show={isVisible}
      years={years}
      value={currentRange}
      lang={PICKER_LANG}
      onChange={handleOnChange}
      onDismiss={() => setVisibility(false)}
    >
      <div className="toggleable-button-root" onClick={() => setVisibility(true)} role="button">
        {viewComponent(currentRange.from)}
        <ArrowIcon className="DateRangePickerInput_arrow_svg" />
        {viewComponent(currentRange.to)}
      </div>
    </Picker>
  );
};

MonthPicker.propTypes = {
  theme: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  calendarStartDate: PropTypes.string,
  calendarEndDate: PropTypes.string,
  updateDates: PropTypes.func
};
export default MonthPicker;
